import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { FollowupState } from '../../types'

export const updateFollowupAction = createAsyncAction(
  '@followup/UPDATE_FOLLOWUP_REQUEST',
  '@followup/UPDATE_FOLLOWUP_SUCCESS',
  '@followup/UPDATE_FOLLOWUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: FollowupState): FollowupState => ({
  ...state,
  isLoadingUpdateFollowup: true,
  isSuccessOnUpdateFollowup: false,
  isErrorOnUpdateFollowup: false
})

const success = (state: FollowupState, action: ActionType<typeof updateFollowupAction.success>): FollowupState => ({
  ...state,
  isLoadingUpdateFollowup: false,
  isSuccessOnUpdateFollowup: true
})

const failure = (state: FollowupState, action: ActionType<typeof updateFollowupAction.failure>): FollowupState => ({
  ...state,
  isLoadingUpdateFollowup: false,
  isErrorOnUpdateFollowup: true
})

export const updateFollowupHandle = { asyncAction: updateFollowupAction, request, success, failure }
